import { render, staticRenderFns } from "./UserPackageCardInfo.vue?vue&type=template&id=07f8a454&"
import script from "./UserPackageCardInfo.vue?vue&type=script&lang=js&"
export * from "./UserPackageCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports